$.view.addHelper({
	/**
	 * Output ISO date in human-friendly format
	 *
	 * @param {Boolean} [time=false]
	 * @param {Boolean} [year=true]
	 * @returns {String}
	 */
	dateFormat(time, year = true) {
		return LS.util.dateFormat(this.val, time, year);
	},

	/**
	 * Format relative age
	 *
	 * @returns {String}
	 */
	dayFormat() {
		return LS.util.dayFormat(this.val);
	},

	/**
	 * Get date different in days
	 *
	 * @returns {Number}
	 */
	dayCount() {
		let num = this.val;

		if (isNaN(num)) {
			num = Math.ceil(
				(new Date().getTime() - new Date(num).getTime()) / 86400000
			);
		}

		return num;
	},

	/**
	 * Format seconds to HH:MM:SS
	 *
	 * @returns {String}
	 */
	timeFormat() {
		const val = this.val;
		const hours = Math.floor(val / 3600);
		const minutes = Math.floor((val - (hours * 3600)) / 60);
		const seconds = val - ((hours * 3600) + (minutes * 60));

		return (hours > 0 ? (hours < 10 ? '0' + hours : hours) + ':' : '') +
			(minutes < 10 ? '0' + minutes : minutes) + ':' +
			(seconds < 10 ? '0' + seconds : seconds);
	},
});